export default __webpack_public_path__ + "static/media/deal-link-arrow.5b947c0f.svg";